import Icon from "@ant-design/icons";
import React from "react";

import { ACIconProps } from "./ACIconWrapper";

export default function PositiveChangeIcon(props: ACIconProps) {
  return <Icon className="ac-icon" component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.45 8C14.45 7.58579 14.7858 7.25 15.2 7.25H20C20.4142 7.25 20.75 7.58579 20.75 8V12.8C20.75 13.2142 20.4142 13.55 20 13.55C19.5858 13.55 19.25 13.2142 19.25 12.8V9.81066L13.7303 15.3303C13.4374 15.6232 12.9626 15.6232 12.6697 15.3303L9.2 11.8607L4.53033 16.5303C4.23744 16.8232 3.76256 16.8232 3.46967 16.5303C3.17678 16.2374 3.17678 15.7626 3.46967 15.4697L8.66967 10.2697C8.96256 9.97678 9.43744 9.97678 9.73033 10.2697L13.2 13.7393L18.1893 8.75H15.2C14.7858 8.75 14.45 8.41421 14.45 8Z"
        fill="currentcolor"
      />
    </svg>
  );
};
